import { render, staticRenderFns } from "./QSupportSubmenu.vue?vue&type=template&id=1796f0e4&"
import script from "./QSupportSubmenu.vue?vue&type=script&lang=js&"
export * from "./QSupportSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports